var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGuber(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny-ps",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 4000 4000",
    width: 4000,
    height: 4000,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Guber(Green)") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\ttspan { white-space:pre }\n\t\t.shp0 { fill: #abfaa3 } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "guber logo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Arrow5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape 3 copy",
    className: "shp0",
    d: "M1340.25 2515.18L1713.02 2726.29L1484.68 3129.49L1111.91 2918.38L1340.25 2515.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer 12",
    className: "shp0",
    d: "M1457.87 3110.76L1571.52 3180.7C1571.52 3180.7 1608.68 3216.7 1606.5 3154.47C1604.31 3092.24 1606.5 2944.64 1606.5 2944.64L1816.32 2813.5C1816.32 2813.5 1860.59 2804.7 1772.61 2761.04C1684.64 2717.39 1676.44 2708.58 1676.44 2708.58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer 16",
    className: "shp0",
    d: "M1477 3125L1584 3190L1591 3183L1589 3161L1541 3122"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer 14",
    className: "shp0",
    d: "M1792 2829L1825 2809C1825 2809 1859.75 2797.22 1713 2727C1566.25 2656.78 1566 2657 1566 2657L1646 2698L1638 2717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer 15",
    className: "shp0",
    d: "M1695 2716L1782 2763L1776 2777L1718 2776L1666 2722L1646 2703"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer 8 copy",
    className: "shp0",
    d: "M1370.73 2538.59L1332.69 2517.05L1108.62 2912.72L1169.52 2947.12L1393.59 2551.45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape 1",
    className: "shp0",
    d: "M1047.26 3047.82C1041.89 3044.72 1038.58 3038.99 1038.59 3032.79L1038.66 2616.97C1038.66 2610.77 1041.97 2605.05 1047.34 2601.95L1407.49 2394.1C1412.85 2391 1419.47 2391 1424.84 2394.1L1047.26 3047.82Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Arrow4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bottom"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer 2",
    className: "shp0",
    d: "M2804.09 2561.77L2354.08 2554.34L2355.08 3059.69L2541.17 3157.03C2541.17 3157.03 2804.03 3169.98 2808.92 2938.09C2813.81 2706.19 2804.09 2561.77 2804.09 2561.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer 11",
    className: "shp0",
    d: "M2354.08 2621.15L2354.08 2481.27L2804.27 2210.24L2804.27 2612.41"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Tip"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer 3",
    className: "shp0",
    d: "M2590.65 3184.23C2590.65 3184.23 2563.61 3219.16 2470.21 3166.26C2376.8 3113.37 2074.61 2942.23 2074.61 2942.23L1850.58 3337.83L2101.63 3480C2101.63 3480 2682.92 3219.74 2590.65 3184.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape 3",
    className: "shp0",
    d: "M1947.52 2867.16L2320.3 3078.27L2091.96 3481.47L1719.18 3270.36L1947.52 2867.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer 13",
    className: "shp0",
    d: "M2069 3468L2091 3481C2091 3481 2094 3484.58 2113 3475C2132 3465.42 2129 3451 2129 3451"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer 8",
    className: "shp0",
    d: "M1978 2890.57L1939.97 2869.03L1715.89 3264.7L1776.79 3299.1L2000.87 2903.43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape 1 copy",
    className: "shp0",
    d: "M1673.26 3417.82C1667.89 3414.72 1664.58 3408.99 1664.59 3402.79L1664.66 2986.97C1664.66 2980.77 1667.97 2975.05 1673.34 2971.95L2033.49 2764.1C2038.85 2761 2045.47 2761 2050.84 2764.1L1673.26 3417.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer 10",
    className: "shp0",
    d: "M2274.65 3052.42L2502.88 3181.67L2459.8 3257.74L2231.57 3128.49L2274.65 3052.42Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Arrow3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tip"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer 7",
    className: "shp0",
    d: "M1597.75 1292.24L1361.7 1432.13L1160.61 1309.73C1160.61 1309.73 1035.3 1058.94 1221.81 977.5C1408.32 896.06 1396.67 890.07 1396.67 890.07L1632.72 1274.75L1597.75 1292.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape 4",
    className: "shp0",
    d: "M1381 880L1189 996L1205 1009C1205 1009 1312 980.47 1313 980C1314 979.53 1365 945 1365 945"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer 5",
    className: "shp0",
    d: "M1511.75 1344.08L1637.85 1271.28L1410.49 877.49L1208.77 994.04L1436.13 1387.84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape 1 copy 3",
    className: "shp0",
    d: "M1297.86 774.05C1303.23 770.95 1309.85 770.95 1315.22 774.05L1675.29 982.03C1680.66 985.13 1683.96 990.86 1683.96 997.05L1683.89 1412.87C1683.89 1419.07 1680.58 1424.8 1675.21 1427.9L1297.86 774.05Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Bottom"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer 3",
    className: "shp0",
    d: "M1122.16 1285.04C1122.16 1285.04 1105.77 1326.05 1198.73 1379.72C1291.69 1433.39 1592.45 1607.04 1592.45 1607.04L1365.14 2000.76L1115.28 1856.5C1115.28 1856.5 1044.76 1223.52 1122.16 1285.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape 2",
    className: "shp0",
    d: "M1364.14 1476.01L1789.27 1721.46L1561.96 2115.18L1136.83 1869.73L1364.14 1476.01Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Arrow2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bottom"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer 2",
    className: "shp0",
    d: "M2804.09 1503.88L2354.08 1496.45L2355.08 2001.8L2541.17 2099.15C2541.17 2099.15 2804.03 2112.09 2808.92 1880.2C2813.81 1648.31 2804.09 1503.88 2804.09 1503.88Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Tip"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape 1 copy 2",
    className: "shp0",
    d: "M1773.26 2407.82C1767.89 2404.72 1764.58 2398.99 1764.59 2392.79L1764.66 1976.97C1764.66 1970.77 1767.97 1965.05 1773.34 1961.95L2133.49 1754.1C2138.85 1751 2145.47 1751 2150.84 1754.1L1773.26 2407.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer 3",
    className: "shp0",
    d: "M2594.17 2129.75C2594.17 2129.75 2566.84 2164.44 2473.89 2110.77C2380.93 2057.11 2080.17 1883.46 2080.17 1883.46L1852.85 2277.18L2102.71 2421.44C2102.71 2421.44 2686.15 2166.02 2594.17 2129.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer 5",
    className: "shp0",
    d: "M2080.17 1883.46L2042.31 1861.6L1814.95 2255.4L1875.57 2290.29L2102.92 1896.5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Arrow1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bottom"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer 2",
    className: "shp0",
    d: "M1650.21 741.44L1868.78 1134.87L2305.93 881.33L2297.18 671.5C2297.18 671.5 2176.97 437.39 1973.7 549.1C1770.42 660.81 1650.21 741.44 1650.21 741.44Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Tip"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer 3",
    className: "shp0",
    d: "M2297.18 610.3C2297.18 610.3 2340.9 616.61 2340.9 723.95C2340.9 831.29 2340.9 1178.58 2340.9 1178.58L2795.53 1178.58L2795.53 890.07C2795.53 890.07 2282.61 512.51 2297.18 610.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape 1 copy 4",
    className: "shp0",
    d: "M2949.56 1178.01C2949.56 1184.21 2946.25 1189.94 2940.88 1193.04L2580.73 1400.88C2575.36 1403.98 2568.75 1403.98 2563.38 1400.88L2203.31 1192.91C2197.94 1189.81 2194.63 1184.08 2194.63 1177.88L2949.56 1178.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer 5",
    className: "shp0",
    d: "M2340.9 1178.58L2340.9 1222.3L2795.61 1222.3L2795.53 1152.35L2340.81 1152.35"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuber);
export default __webpack_public_path__ + "static/media/guber.c94af84afc17ccedf9db292ef1643bb2.svg";
export { ForwardRef as ReactComponent };